import React, { useState, useContext } from "react";
import {
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  Typography,
  Stack,
  Box,
  Collapse,
} from "@mui/material";
import MuiDrawer from "@mui/material/Drawer";
import { styled } from "@mui/material/styles";
import { useLocation, useNavigate } from "react-router-dom";
//Icons
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { AiOutlineDashboard, AiOutlineSetting } from "react-icons/ai";
import { VscGraph } from "react-icons/vsc";
import { LiaFileInvoiceDollarSolid } from "react-icons/lia";
import { RiMoneyDollarCircleLine } from "react-icons/ri";
import { MdOutlineFactCheck } from "react-icons/md";
import { TbFileDollar, TbFileInvoice } from "react-icons/tb";
import { PiStudentBold } from "react-icons/pi";
import { RiFolderUploadLine } from "react-icons/ri";
import { MdOutlineAccountBalanceWallet } from "react-icons/md";
import { FiSend } from "react-icons/fi";
import { IoMdSend } from "react-icons/io";
//Srcs
import CompanyLogo from "../../Assets/School_logo.svg";
import "./menunavbar.scss";
import { AuthContext } from "../../Context/AuthContext";
import { translateLauguage } from "../../Function/Translate";

const drawerWidth = 260;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  height: "100%",
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  margin: "0px",
  alignItems: "center",
  justifyContent: "center",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

export default function MenuNavbar({ open, toggleDrawer }) {
  // Change Language
  const { language } = useContext(AuthContext);
  const { t } = translateLauguage(language);

  let location = useLocation();
  const navigate = useNavigate();

  const [openDisbursement, setOpenDisbursement] = useState(false);
  const handleOpenDisbursement = () => {
    setOpenDisbursement(!openDisbursement);
  };

  const [openPayment, setOpenPayment] = useState(false);
  const handleOpenPayment = () => {
    setOpenPayment(!openPayment);
    setOpenDisbursement(false);
  };
  const [openIncome, setOpenIncome] = useState(false);
  const handleOpenIncome = () => {
    setOpenIncome(!openIncome);
  };

  const handleCloseSubMenu = () => {
    toggleDrawer("left", false);
  };

  return (
    <Drawer variant="permanent" open={true} className="drawer-menu">
      <DrawerHeader sx={{ mt: 2 }}>
        <Stack direction="row" justifyContent="center" sx={{ width: "100%" }}>
          <IconButton
            onClick={() => navigate("/dashboard")}
            className="image-container"
          >
            <img src={CompanyLogo} alt="logo" className="logo" />
          </IconButton>
        </Stack>
      </DrawerHeader>

      <List className="list-menu">
        {/* ============================== page dashboard ========================== */}
        {/* <ListItem
          className={
            location.pathname === "/dashboard"
              ? "list-item-active"
              : "list-item"
          }
          disablePadding
          onClick={() => {
            navigate("/");
            handleCloseSubMenu();
          }}
        >
          <ListItemButton className="list-item-button">
            <ListItemIcon className="list-item-icon">
              <AiOutlineDashboard className="icon" />
            </ListItemIcon>
            <Typography className="list-item-text">
              {t("page_dashboard")}
            </Typography>
          </ListItemButton>
        </ListItem> */}


        {/* ============================ Page Income =========================== */}
        {/* <ListItem
          className={
            location.pathname === "/income" ||
              location.pathname === "/disbursement/create-disbursement"
              ? "list-item-active"
              : "list-item"
          }
          disablePadding
          onClick={() => {
            navigate("/income");
            handleOpenIncome();
          }}
        >
          <ListItemButton className="list-item-button">
            <ListItemIcon className="list-item-icon">
              <MdOutlineAccountBalanceWallet className="icon" />
            </ListItemIcon>
            <Typography className="list-item-text">
              {t("page_income")}
            </Typography>
            <Box sx={{ flexGrow: 1 }} />
            {openIncome ? (
              <ExpandLess
                className={
                  location.pathname === "/income" ||
                    location.pathname === "/disbursement/create-disbursement"
                    ? "submenu-icon-active"
                    : "submenu-icon-active"
                }
              />
            ) : (
              <ExpandMore
                className={
                  location.pathname === "/income" ||
                    location.pathname === "/disbursement/create-disbursement"
                    ? "submenu-icon-active"
                    : "submenu-icon-active"
                }
              />
            )}
          </ListItemButton>
        </ListItem> */}

        {/* <Collapse in={openIncome} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItem
              className={
                location.pathname === "/income" ||
                  location?.pathname === "/disbursement/create-disbursement"
                  ? "list-item-active"
                  : "list-item"
              }
              disablePadding
              onClick={() => {
                navigate("/income");
                handleCloseSubMenu();
              }}
            >
              <ListItemButton
                className="list-item-button"
                sx={{ paddingLeft: "40px" }}
              >
                <ListItemIcon className="list-item-icon">
                  <LiaFileInvoiceDollarSolid className="icon" />
                </ListItemIcon>
                <Typography className="list-item-text">
                  {t("page_bill")}
                </Typography>
              </ListItemButton>
            </ListItem>
          </List>
        </Collapse> */}

        <Collapse in={openIncome} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>

            {/* ============== Item ========= */}
            <ListItem
              className={
                location.pathname === "/income" ||
                  location?.pathname === "/disbursement/create-disbursement"
                  ? "list-item-active"
                  : "list-item"
              }
              disablePadding
              onClick={() => navigate("/income")}
            >
              <ListItemButton
                className="list-item-button"
                sx={{ paddingLeft: "40px" }}
              >
                <ListItemIcon className="list-item-icon">
                  <TbFileDollar className="icon" />
                </ListItemIcon>
                <Typography className="list-item-text">
                  {/* {t("page_bill")} */} Receipt
                </Typography>
              </ListItemButton>
            </ListItem>

            {/* ============== Item ========= */}
            <ListItem
              className={
                location?.pathname === "/generalincome"
                  ? "list-item-active"
                  : "list-item"
              }
              disablePadding
              onClick={() => navigate("/generalincome")}
            >
              <ListItemButton
                className="list-item-button"
                sx={{ paddingLeft: "40px" }}
              >
                <ListItemIcon className="list-item-icon">
                  <TbFileDollar className="icon" />
                </ListItemIcon>
                <Typography className="list-item-text">
                  {/* {t("page_general_bill")} */}
                  General Receipt
                </Typography>
              </ListItemButton>
            </ListItem>


          </List>
        </Collapse>

        {/* ============================ Page Disbursement =========================== */}
        <ListItem
          className={
            location.pathname === "/disbursement" ||
              location.pathname === "/disbursement/create-disbursement" ||
              location.pathname === "/pay-disbursement"
              ? "list-item-active"
              : "list-item"
          }
          disablePadding
          onClick={() => {
            navigate("/disbursement");
            handleOpenDisbursement();
          }}
        >
          <ListItemButton className="list-item-button">
            <ListItemIcon className="list-item-icon">
              <RiFolderUploadLine className="icon" />
            </ListItemIcon>
            <Typography className="list-item-text">
              {t("page_expense")}
            </Typography>
            <Box sx={{ flexGrow: 1 }} />
            {openDisbursement ? (
              <ExpandLess
                className={
                  location.pathname === "/disbursement" ||
                    location.pathname === "/disbursement/create-disbursement"
                    ? "submenu-icon-active"
                    : "submenu-icon-active"
                }
              />
            ) : (
              <ExpandMore
                className={
                  location.pathname === "/disbursement" ||
                    location.pathname === "/disbursement/create-disbursement"
                    ? "submenu-icon-active"
                    : "submenu-icon-active"
                }
              />
            )}
          </ListItemButton>
        </ListItem>
        <Collapse in={openDisbursement} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItem
              className={
                location.pathname === "/disbursement" ||
                  location?.pathname === "/disbursement/create-disbursement"
                  ? "list-item-active"
                  : "list-item"
              }
              disablePadding
              onClick={() => {
                navigate("/disbursement");
                handleCloseSubMenu();
              }}
            >
              <ListItemButton
                className="list-item-button"
                sx={{ paddingLeft: "40px" }}
              >
                <ListItemIcon className="list-item-icon">
                  <LiaFileInvoiceDollarSolid className="icon" />
                </ListItemIcon>
                <Typography className="list-item-text">
                  {t("page_disbursement")}
                </Typography>
              </ListItemButton>
            </ListItem>


            {/* <ListItem
              className={
                location.pathname === "/pay-disbursement" ||
                  location?.pathname === "/disbursement/create-disbursement"
                  ? "list-item-active"
                  : "list-item"
              }
              disablePadding
              onClick={() => {
                navigate("/pay-disbursement");
                handleCloseSubMenu();
              }}
            >
              <ListItemButton
                className="list-item-button"
                sx={{ paddingLeft: "40px" }}
              >
                <ListItemIcon className="list-item-icon">
                  <LiaFileInvoiceDollarSolid className="icon" />
                </ListItemIcon>
                <Typography className="list-item-text">
                  Pay Disbursement
                </Typography>
              </ListItemButton>
            </ListItem> */}


            {/* <ListItem
              className={
                location.pathname === "/payment-expenses"
                  ? "list-item-active"
                  : "list-item"
              }
              disablePadding
              onClick={() => navigate("/payment-expenses")}
            >
              <ListItemButton
                className="list-item-button"
                sx={{ paddingLeft: "30px" }}
              >
                <ListItemIcon className="list-item-icon">
                  <AiOutlineDollar className="icon" />
                </ListItemIcon>
                <Typography className="list-item-text">
                  {t("page_payment_income")}
                </Typography>
              </ListItemButton>
            </ListItem> */}
          </List>
        </Collapse>

        {/* ================================ Student Payment ================================= */}
        {/* <ListItem
          className={
            location.pathname === "/school-service" ||
            location.pathname === "/school-fee"
              ? "list-item-active"
              : "list-item"
          }
          disablePadding
          onClick={() => handleOpenPayment()}
        >
          <ListItemButton className="list-item-button">
            <ListItemIcon className="list-item-icon">
              <TbReportMoney className="icon" />
            </ListItemIcon>
            <Typography className="list-item-text">Student Payment</Typography>
            <Box sx={{ flexGrow: 1 }} />
            {openPayment ? (
              <ExpandLess
                className={
                  location.pathname === "/school-service" ||
                  location.pathname === "/school-fee"
                    ? "submenu-icon-active"
                    : "submenu-icon-active"
                }
              />
            ) : (
              <ExpandMore
                className={
                  location.pathname === "/school-service" ||
                  location.pathname === "/school-fee"
                    ? "submenu-icon-active"
                    : "submenu-icon-active"
                }
              />
            )}
          </ListItemButton>
        </ListItem> */}

        {/* =================================== */}
        {/* <Collapse in={openPayment} timeout="auto" unmountOnExit>
          <List component="div" disablePadding className="list-menu">
            <ListItem
              className={
                location.pathname === "/school-service"
                  ? "list-item-active"
                  : "list-item"
              }
              disablePadding
              onClick={() => {
                navigate("/school-service");
                handleCloseSubMenu();
              }}
            >
              <ListItemButton
                className="list-item-button"
                sx={{ paddingLeft: "35px" }}
              >
                <ListItemIcon className="list-item-icon">
                  <TbReportMoney className="icon" />
                </ListItemIcon>
                <Typography className="list-item-text">
                  School Service
                </Typography>
              </ListItemButton>
            </ListItem>

            <ListItem
              className={
                location.pathname === "/school-fee"
                  ? "list-item-active"
                  : "list-item"
              }
              disablePadding
              onClick={() => {
                navigate("/school-fee");
                handleCloseSubMenu();
              }}
            >
              <ListItemButton
                className="list-item-button"
                sx={{ paddingLeft: "35px" }}
              >
                <ListItemIcon className="list-item-icon">
                  <RiMoneyDollarCircleLine className="icon" />
                </ListItemIcon>
                <Typography className="list-item-text">School Fee</Typography>
              </ListItemButton>
            </ListItem>
          </List>
        </Collapse> */}

        {/* ============================== page student ========================== */}
        {/* <ListItem
          className={
            location.pathname === "/student" ||
              location.pathname === "/students/student-detail"
              ? "list-item-active"
              : "list-item"
          }
          disablePadding
          onClick={() => {
            navigate("/student");
            handleCloseSubMenu();
          }}
        >
          <ListItemButton className="list-item-button">
            <ListItemIcon className="list-item-icon">
              <PiStudentBold className="icon" />
            </ListItemIcon>
            <Typography className="list-item-text">Student</Typography>
          </ListItemButton>
        </ListItem> */}

        {/* ================================ Page Invoice ============================= */}
        {/* <ListItem
          className={
            location.pathname === "/invoice" || location.pathname === "/invoice"
              ? "list-item-active"
              : "list-item"
          }
          disablePadding
          onClick={() => navigate("/invoice")}
        >
          <ListItemButton className="list-item-button">
            <ListItemIcon className="list-item-icon">
              <TbFileInvoice className="icon" />
            </ListItemIcon>
            <Typography className="list-item-text">Invoice</Typography>
          </ListItemButton>
        </ListItem> */}

        {/* ============================ Page set payment notification ==================== */}
        {/* <ListItem
          className={
            location.pathname === "/send-notification"
              ? "list-item-active"
              : "list-item"
          }
          disablePadding
          onClick={() => navigate("/send-notification")}
        >
          <ListItemButton className="list-item-button">
            <ListItemIcon className="list-item-icon">
              <IoMdSend className="icon" />
            </ListItemIcon>
            <Typography className="list-item-text">
              Invoice announcement
            </Typography>
          </ListItemButton>
        </ListItem> */}

        {/* ============================== page report ========================== */}
        <ListItem
          className={
            location.pathname === "/report" ||
              location.pathname === "/report/student-tuition-report" ||
              location.pathname === "/report/student-statistic-by-academic-year"
              ? "list-item-active"
              : "list-item"
          }
          disablePadding
          onClick={() => {
            navigate("/report");
            handleCloseSubMenu();
          }}
        >
          <ListItemButton className="list-item-button">
            <ListItemIcon className="list-item-icon">
              <VscGraph className="icon" />
            </ListItemIcon>
            <Typography className="list-item-text">Report</Typography>
          </ListItemButton>
        </ListItem>
      </List>

      <Box sx={{ flexGrow: 1 }} />

      <List className="list-menu">
        {/* =============================== Page Setting =============================== */}
        <ListItem
          className={
            location.pathname === "/setting" ||
              location.pathname === "/setting/fee" ||
              location.pathname === "/setting/users" ||
              location.pathname === "/setting/supplier" ||
              location.pathname === "/setting/customer" ||
              location.pathname === "/setting/gruop-fee" ||
              location.pathname === "/setting/list-item" ||
              location.pathname === "/setting/exspense-type" ||
              location.pathname === "/setting/exspense-group" ||
              location.pathname === "/setting/head-income"
              ? "list-item-active"
              : "list-item"
          }
          disablePadding
          onClick={() => {
            navigate("/setting");
            handleCloseSubMenu();
          }}
        >
          <ListItemButton className="list-item-button">
            <ListItemIcon className="list-item-icon">
              <AiOutlineSetting className="icon" />
            </ListItemIcon>
            <Typography className="list-item-text">
              {t("page_setting")}
            </Typography>
          </ListItemButton>
        </ListItem>
      </List>
    </Drawer>
  );
}
